import { useEffect, useState } from 'react'
import styles from './AccountSelect.module.scss'
import { AiFillMinusSquare, AiFillCheckSquare } from 'react-icons/ai'
import { MdCheckBoxOutlineBlank } from 'react-icons/md'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'
import { IoIosArrowForward } from 'react-icons/io'

type Props = {
    parent: any,
    hasChild: boolean,
    handleClick: Function,
    selectedCustomers: any,
    hardSelect: boolean,
    showConnectedTag: boolean,
    // isIgnoreId?: boolean
}

const AccountSelect = ({ parent, hasChild, handleClick, selectedCustomers, hardSelect, showConnectedTag }: Props) => {


    // console.log('showConnectedTag', showConnectedTag)
    return (
        <>
            <div className={styles.acc} onClick={() => { if (!hardSelect) { handleClick(parent) } }}>
                <div className={styles.finalAccount}>
                    {
                        !hasChild ?
                            <div className={styles.checkbox}>
                                {
                                    hardSelect ? <AiFillCheckSquare /> :
                                        selectedCustomers[parent?.id]?.selected ?
                                            <AiFillCheckSquare /> :
                                            <MdCheckBoxOutlineBlank className={styles.accSelect} />
                                }
                            </div> : null
                    }
                    {
                        parent?.name ?
                            <div className={styles.disGap}>
                                <h3>{parent?.name}
                                    {
                                        showConnectedTag ? <span>Connected</span> : null
                                    }
                                </h3>
                                <p>{parent?.id}</p>
                            </div>
                            : <h3>{parent?.id}</h3>
                    }
                </div>
                {
                    hasChild ? <IoIosArrowForward /> : null
                }
            </div>
        </>
    )
}

export default AccountSelect